import React from 'react';
import Svg from 'rp-react-svg-icon';

const Loading = () => (
    <div className="ui-centered-wrapper">
        <Svg
            isInlined
            iconName="spinner"
            size="2XL"
            className="ui-animation_spinnerAnimation"
        />
    </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/Loading/Loading.jsx